import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { isValidHexColor } from "@perxis-auto/shared";
import classnames from "../../utils/classnames.js";
import Checkbox from "../Checkbox/Checkbox.js";
import Tooltip from "../Tooltip/Tooltip.js";
import './DuoColorPicker.css';/* empty css                    */
const DuoColorPicker = ({
  options,
  className,
  showLabel = true,
  showTooltip = false,
  ...props
}) => {
  const extendedOptions = useMemo(() => {
    return options == null ? void 0 : options.map(({ color, additionalColor, ...item }) => {
      const validatedColor = isValidHexColor(color) ? color : null;
      const validatedAdditionalColor = isValidHexColor(additionalColor) ? additionalColor : null;
      return {
        ...item,
        color: validatedColor,
        additionalColor: validatedAdditionalColor
      };
    });
  }, [options]);
  return /* @__PURE__ */ jsx(Checkbox.Group, { className: classnames("perxis-auto-duo-color-picker", className), ...props, children: extendedOptions == null ? void 0 : extendedOptions.map(
    ({ label, value, color, additionalColor, additionalColorName, style, ...checkboxProps }) => {
      const checkbox = /* @__PURE__ */ jsx(
        Checkbox,
        {
          className: classnames(
            [
              "perxis-auto-duo-color-picker__item",
              {
                "perxis-auto-duo-color-picker__item--additional-color": additionalColor
              }
            ],
            className
          ),
          value,
          style: {
            "--perxis-auto-duo-color-picker-main-color": color,
            "--perxis-auto-duo-color-picker-additional-color": additionalColor,
            ...style
          },
          ...checkboxProps,
          children: showLabel ? label : void 0
        },
        value
      );
      return showTooltip ? /* @__PURE__ */ jsx(Tooltip, { title: label, children: checkbox }, `tooltip-${value}`) : checkbox;
    }
  ) });
};
export {
  DuoColorPicker as default
};
//# sourceMappingURL=DuoColorPicker.js.map
